import { LoginForm } from "@portal/Components/Login/LoginForm";

function Login() {
  return <LoginForm />;
}

export { Login };
